<template>
  <div id="fade">
    <head-menu
      v-if="path != '/login' && path != '/register'"
    ></head-menu>
    <router-view></router-view>
    <foot-menu v-if="path != '/login' && path != '/register'"></foot-menu>
  </div>
</template>

<script>
import HeadMenu from './components/header'
import FootMenu from './components/footer'
export default {
  name: 'fade',
  components: {HeadMenu, FootMenu},
  data () {
    return {
      path: ''
    }
  },
  mounted () {
    this.path = this.$route.path
  },
  watch: {
    $route (to, from) {
      // 对路由变化作出响应...
      this.path = to.path
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue